import { XMarkIcon, CurrencyDollarIcon, PencilSquareIcon, DocumentTextIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { formatPrice } from '../../helpers/common';

export const BulkBar = ({
    count,
    owedTotal,
    onAddPayment,
    onEditPayments,
    onSetInvoices,
    onSync,
    syncing,
    onClear,
    testId
}) => {
    if (count === 0) return null;
    return (
        <div
            className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-gray-900 text-white shadow-[0_-4px_16px_rgba(0,0,0,0.25)] pb-[env(safe-area-inset-bottom)]"
            data-testid={testId}
        >
            <div className="flex items-center gap-2 px-3 pt-2">
                <span className="text-sm font-semibold tabular-nums whitespace-nowrap">{count} selected</span>
                <span className="text-xs text-white/60 tabular-nums whitespace-nowrap">Owed: ${formatPrice(owedTotal)}</span>
                <button
                    onClick={onClear}
                    className="ml-auto p-1.5 rounded hover:bg-white/10 transition-colors"
                    aria-label="Clear selection"
                >
                    <XMarkIcon className="h-4 w-4" />
                </button>
            </div>
            <div className="flex items-center gap-2 px-3 py-2.5 overflow-x-auto">
                    <button
                        onClick={onAddPayment}
                        className="flex shrink-0 items-center gap-1.5 h-9 px-3.5 rounded-md bg-white text-black text-[13px] font-semibold whitespace-nowrap hover:bg-gray-200 transition-colors"
                    >
                        <CurrencyDollarIcon className="h-4 w-4" /> Add Payment
                    </button>
                    {onEditPayments && (
                        <button
                            onClick={onEditPayments}
                            className="flex shrink-0 items-center gap-1.5 h-9 px-3.5 rounded-md bg-white/15 text-white text-[13px] font-medium whitespace-nowrap hover:bg-white/20 transition-colors"
                        >
                            <PencilSquareIcon className="h-4 w-4" /> Edit Payment
                        </button>
                    )}
                    {onSetInvoices && (
                        <button
                            onClick={onSetInvoices}
                            className="flex shrink-0 items-center gap-1.5 h-9 px-3.5 rounded-md bg-white/15 text-white text-[13px] font-medium whitespace-nowrap hover:bg-white/20 transition-colors"
                        >
                            <DocumentTextIcon className="h-4 w-4" /> Invoice #
                        </button>
                    )}
                    {onSync && (
                        <button
                            onClick={onSync}
                            disabled={syncing}
                            className="flex shrink-0 items-center gap-1.5 h-9 px-3.5 rounded-md bg-white/15 text-white text-[13px] font-medium whitespace-nowrap hover:bg-white/20 transition-colors disabled:opacity-50"
                        >
                            <ArrowPathIcon className={`h-4 w-4 ${syncing ? 'animate-spin' : ''}`} /> Sync
                        </button>
                    )}
            </div>
        </div>
    );
};
